import request from '../request';

export const createTransaction = (data = {}) =>
  request.post('transactions', data).then((res) => res);
